import styles from "./styles.module.scss";

const FormInput = ({ label, type = "text", value, onChange, placeholder }) => (
  <div className={styles.formGroup}>
    <label className={styles.formLabel}>{label}</label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      className={styles.formInput}
      placeholder={placeholder}
    />
  </div>
);

export default FormInput;
